import React from "react";
import styled from "styled-components";

import LineSeedKrBd from "../../../../atoms/text/lineSeedKr/lineSeedKrBd";

const LSBdCaption03 = (props) => {
  return <LSBdCaption03Wrapper {...props} />;
};

export default LSBdCaption03;

const LSBdCaption03Wrapper = styled(LineSeedKrBd)`
  font-size: 13px;
  font-weight: 700;
  line-height: 15.6px;
  letter-spacing: -0.3px;

  color: #222222;
`;
